import React from 'react';
import { Box, Button, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useI18n } from "../../i8n/useI18n";

const CheckoutDemoPage = () => {
    const { t } = useI18n();

    return (
        <Box sx={{ maxWidth: "600px", margin: "0 auto", padding: "120px 4%", textAlign: "center" }}>
            <Helmet>
                <title>{t("checkoutDemoPage.title")} | {t("brand.name")}</title>
            </Helmet>
            <Typography variant="overline" color="primary.main" gutterBottom>{t("brand.name")}</Typography>
            <Typography variant="h3" gutterBottom>{t("checkoutDemoPage.title")}</Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                {t("checkoutDemoPage.message")}
            </Typography>
            <Button variant="contained" component={RouterLink} to={t("links.shop")}>
                {t("checkoutDemoPage.backToShopCta")}
            </Button>
        </Box>
    );
};

export default CheckoutDemoPage;
